module.exports = __webpack_public_path__ + "static/media/card-logo-7.8bca53f1.svg";